'use client'

import { Col, Row } from 'react-bootstrap'

import logo9 from '@/assets/images/akpk.webp'
import logo8 from '@/assets/images/bnm.webp'
import fmos from '@/assets/images/fmos-logo.webp'
import logo13 from '@/assets/images/housing.webp'
import logo2 from '@/assets/images/logo2.webp'
import logo3 from '@/assets/images/logo3.webp'
import logo4 from '@/assets/images/logo4.webp'
import logo5 from '@/assets/images/logo5.webp'
import logo6 from '@/assets/images/logo6.webp'
import logo11 from '@/assets/images/logo11.webp'
import logo12 from '@/assets/images/paynet.webp'
import logo1 from '@/assets/images/pidm.webp'
import logo14 from '@/assets/images/sac.webp'

const SubFooter = () => {
  // Keep the imported image objects (StaticImageData) rather than just `.src`,
  // so each <img> can emit its INTRINSIC width/height. Setting width="100%"
  // height="100%" previously forced a 1:1 attribute aspect ratio that did not
  // match the displayed ~Nx31 box — Lighthouse flags that as "incorrect aspect
  // ratio". Intrinsic dims + CSS (height:31px; width:auto) keep the ratio exact.
  const links = [
    {
      href: 'https://www.pidm.gov.my/',
      img: logo1,
      alt: 'Image 1'
    },
    {
      href: 'https://www.ibfim.com/',
      img: logo2,
      alt: 'Image 2'
    },
    {
      href: 'https://www.smeinfo.com.my/',
      img: logo3,
      alt: 'Image 3'
    },
    {
      img: logo4,
      alt: 'Image 4'
    },
    {
      href: 'https://www.mifc.com/',
      img: logo5,
      alt: 'Image 5'
    },
    {
      href: 'https://aibim.com/',
      img: logo6,
      alt: 'Image 6'
    },
    // {
    //   href: "https://www.ofs.org.my/en/",
    //   imgSrc: logo7,
    //   alt: "Image 7",
    // },
    {
      href: 'https://www.paynet.my/',
      img: logo12,
      alt: 'Image 12'
    },
    {
      href: 'https://www.bnm.gov.my/',
      img: logo8,
      alt: 'Image 8'
    },

    {
      href: 'https://www.akpk.org.my/',
      img: logo9,
      alt: 'Image 9'
    },
    {
      href: 'https://www.fmos.org.my/en/',
      img: fmos,
      alt: 'Image FMOS'
    },
    // {
    //   href: "https://www.sidrec.com.my/",
    //   imgSrc: logo10,
    //   alt: "Image 10",
    // },
    {
      href: 'https://insuranceinfo.com.my/',
      img: logo11,
      alt: 'Image 11'
    },

    {
      href: 'https://www.housingwatch.my/',
      img: logo13,
      alt: 'Image 13'
    },
    {
      href: 'https://www.bnm.gov.my/shariah-advisory-council',
      img: logo14,
      alt: 'Image 12'
    }
    // {
    //   href: "https://www.akpk.org.my/",
    //   imgSrc: "assets/img/image14.svg",
    //   alt: "Image 14",
    // },
    // Uncomment the next line if you want to include it
    // { href: "https://sidrec.com.my/", imgSrc: "assets/img/image15.svg", alt: "Image 15" },
  ]

  return (
    // <div className="container subfooter-container d-flex align-items-center justify-content-between">
    <div className="container subfooter-container ">
      <Row>
        <Col md={1}>
          <p className="mb-0 subfooter-title pb-3" data-translate="footer_6_3">
            Related Links:
          </p>
        </Col>
        <Col md={11}>
          <div className="d-flex flex-wrap gap-2 justify-content-evenly">
            {links.map(link =>
              link.href ? (
                <a
                  className="footer-logo"
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={link.href}
                >
                  <img
                    src={link.img.src}
                    alt={link.alt}
                    width={link.img.width}
                    height={link.img.height}
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              ) : (
                <span className="footer-logo" key={link.alt}>
                  <img
                    src={link.img.src}
                    alt={link.alt}
                    width={link.img.width}
                    height={link.img.height}
                    loading="lazy"
                    decoding="async"
                  />
                </span>
              )
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SubFooter
